<template>
    <div class="tab-content-container">
        <WorkerStatuses/>

        <!--    Company    -->

        <div class="tab-header-container">
            <h2 class="form-label">Фирма</h2>
            <LiteButton @click.native="shouldEditCompany = true"
                        class="edit-button"
                        v-show="!shouldEditCompany"
                        :hoverColor="'blue'"
                        :icon="'far fa-edit'">
            </LiteButton>
            <LiteButton @click.native="shouldEditCompany = false"
                        style="font-size: 27px;"
                        class="edit-button"
                        v-show="shouldEditCompany"
                        :hoverColor="'red'"
                        :icon="'far fa-window-close'">
            </LiteButton>
        </div>

        <hr class="form-line">

        <div class="item-container very-light-shadow"
             v-if="!shouldEditCompany && workerCompany && workerCompany.id">

            <p class="item-label" v-text="workerCompany.name"></p>

            <p class="item-label item-label-info" v-if="workerCompany.address">
                Адрес: {{workerCompany.address}}
            </p>
        </div>

        <div v-if="shouldEditCompany" class="edit-company-container">
            <SelectDropDown class="input-worker-company"
                            @selection-change="workerCompanyChanged"
                            :id="'workerCompany'"
                            :name="'workerCompany'"
                            :label="'Фирма'"
                            :options="companies"
                            :placeholder="'Изберете фирма'"
                            :defaultSelected="getDefaultSelectedCompany">
            </SelectDropDown>

            <Button class="save-company-button"
                    @click.native="saveCompany"
                    :color="'green'"
                    :text="'Запази'"
                    :icon="'fa fa-save'"></Button>
        </div>

        <!--    Professions    -->
        <hr class="form-line" style="margin-top: 40px;">

        <div class="tab-header-container">
            <h2 class="form-label">Професии</h2>
            <LiteButton @click.native="editButtonClicked"
                        class="edit-button"
                        v-show="!shouldEditProfessions"
                        :hoverColor="'blue'"
                        :icon="'far fa-edit'">
            </LiteButton>
            <LiteButton @click.native="editButtonClicked"
                        style="font-size: 27px;"
                        class="edit-button"
                        v-show="shouldEditProfessions"
                        :hoverColor="'red'"
                        :icon="'far fa-window-close'">
            </LiteButton>
        </div>

        <hr class="form-line">

        <div class="item-container very-light-shadow"
             v-for="profession in workerProfessions" :key="profession.professionId + '_profession'">

            <p class="item-label" v-text="getProfessionName(profession)"></p>

            <p class="item-label item-label-info" v-if="!shouldEditProfessions">
                Квалификация: {{getProfessionQualification(profession)}}
            </p>

            <SelectDropDown class="input-worker-qualification"
                            v-if="shouldEditProfessions"
                            @selection-change="workerQualificationChanged"
                            :id="'worker-qualification-edit_' + profession.professionId"
                            :name="'worker-qualification-edit'"
                            :label="'Квалификация'"
                            :options="workerQualificationsCache"
                            :placeholder="'Изберете квалификация'"
                            :defaultSelected="getDefaultSelectedQualification(profession.professionQualification)"
                            :initialValue="profession.professionQualification + ''">
            </SelectDropDown>

            <LiteButton @click.native="removeProfession(profession)"
                        class="edit-button delete-icon"
                        v-show="canRemoveProfession(profession)"
                        :hoverColor="'red'"
                        :icon="'far fa-trash-alt'">
            </LiteButton>

            <div class="last-modified-container">
                <p class="last-modified-date" v-text="getLastModifiedDate(profession)"></p>
                <p class="last-modified-name" v-text="getLastModifiedBy(profession)"></p>
            </div>
        </div>

        <div class="add-item-container" v-if="shouldShowAddProfession">
            <SelectDropDown class="item-dropdown"
                            :id="'profession'"
                            :name="'profession'"
                            @selection-change="professionSelected"
                            :options="getProfessionsForDropDown"
                            :label="'Добавяне на професия'"
                            :placeholder="'Изберете професия'">
            </SelectDropDown>
            <LiteButton @click.native="addProfession"
                        class="add-item-icon"
                        :hoverColor="'green'"
                        :icon="'far fa-plus-square'">
            </LiteButton>
        </div>
        <Button class="save-button"
                v-if="shouldEditProfessions"
                @click.native="saveProfessions"
                :color="'green'"
                :text="'Запази'"
                :icon="'fa fa-save'"></Button>

        <!--    Teams    -->
        <hr class="form-line" style="margin-top: 40px;">

        <div class="tab-header-container">
            <h2 class="form-label">Екипи</h2>
        </div>

        <hr class="form-line">

        <div class="item-container very-light-shadow"
             v-for="team in workerTeams" :key="team.teamId">
            <a @click="redirectToTeam(team.teamId)">
                <i class="fa fa-info-circle info-icon"></i>
            </a>
            <p class="item-label" v-text="team.teamName"></p>

            <p class="item-label item-label-info">({{team.professionName}})</p>

            <div class="last-modified-container">
                <p class="last-modified-date" v-text="getLastModifiedDate(team)"></p>
                <p class="last-modified-name" v-text="getLastModifiedBy(team)"></p>
            </div>
        </div>
    </div>
</template>

<script>
    import LiteButton from "@/shared/components/button/LiteButton";
    import {mapGetters} from 'vuex';
    import mapperService from "@/services/mapper.service";
    import Button from "@/shared/components/button/Button";
    import SelectDropDown from "@/shared/components/form/SelectDropDown";
    import workerService from "@/services/worker.service";
    import {cloneDeep} from 'lodash';
    import redirectService from "@/services/redirect.service";
    import WorkerStatuses from "@/components/worker/form/WorkerStatuses";
    import sharedService from "@/services/shared.service";

    export default {
        name: "WorkerProfessionalProfile",
        components: {WorkerStatuses, SelectDropDown, LiteButton, Button},
        created() {
            sharedService.fetchCompanies()
                .then(({data}) => {
                    this.companies = [];
                    this.companies.push({
                        id: 'none',
                        name: '-'
                    });
                    data.forEach(company => this.companies.push(company));
                });
            this.$store.dispatch('fetchAllProfessions');
            this.workerProfessions = cloneDeep(this.professions);
            this.workerQualificationsCache = this.getWorkerQualifications();
        },
        data() {
            return {
                workerId: this.$route.params.id,
                shouldEditProfessions: false,
                workerProfessions: [],
                selectedProfession: null,
                shouldEditStatuses: false,
                shouldEditCompany: false,
                companies: null,
                selectedCompany: null,
                workerQualificationsCache: this.getWorkerQualifications()
            }
        },
        methods: {
            getDefaultSelectedQualification(qualification) {
                return this.workerQualificationsCache.find(temp => temp.id === qualification);
            },
            getWorkerQualifications() {
                let temp = cloneDeep(this.allWorkerQualifications);
                if (!temp || !Array.isArray(temp)) {
                    return [];
                }

                return temp
                    // remove qualification type NONE
                    .filter(tempItem => tempItem !== 0)
                    // map the items so that they can be displayed into dropdown
                    .map(tempItem => {
                        return {
                            id: tempItem,
                            name: tempItem
                        }
                    });
            },
            getProfessionName(profession) {
                let temp = profession.professionName;
                if (profession.professionCode) {
                    temp += ' (код: ' + profession.professionCode + ')';
                }
                return temp;
            },
            workerQualificationChanged(value) {
                const professionId = value.dropDownId.split('_')[1];
                const {currentValue} = value;
                this.workerProfessions.map(workerProfession => {
                    if (workerProfession.professionId + '' === professionId) {
                        workerProfession.professionQualification = currentValue.id;
                    }
                    return workerProfession;
                });
            },
            editButtonClicked() {
                this.shouldEditProfessions = !this.shouldEditProfessions;
                this.workerProfessions = cloneDeep(this.professions);
                this.selectedProfession = null;
            },
            getLastModifiedDate(object) {
                return mapperService.getLastModifiedDate(object);
            },
            getLastModifiedBy(object) {
                return mapperService.getLastModifiedBy(object);
            },
            professionSelected(profession) {
                this.selectedProfession = profession;
            },
            addProfession() {
                if (this.selectedProfession) {
                    this.workerProfessions.push(
                        {
                            professionName: this.selectedProfession.currentValue.name,
                            professionId: this.selectedProfession.currentValue.id
                        }
                    );
                }
            },
            removeProfession(profession) {
                this.workerProfessions = this.workerProfessions.filter((temp) => temp.professionId !== profession.professionId);
            },
            saveProfessions() {
                workerService.updateProfessions(this.workerId, this.workerProfessions)
                    .then(({data}) => {
                        this.$store.commit('setProfessions', data);
                        this.shouldEditProfessions = false;
                    })
            },
            workerCompanyChanged(value) {
                this.selectedCompany = value.currentValue;
            },
            saveCompany() {
                let company = null;
                if (this.selectedCompany) {
                    company = this.selectedCompany;
                } else {
                    company = this.getDefaultSelectedCompany();
                }
                if (company.id === 'none') {
                    company.id = 0;
                }
                workerService.updateWorkerCompany(this.workerId, company)
                    .then(({data}) => {
                        this.$store.commit('setWorkerCompany', data);
                        this.shouldEditCompany = false;
                    });
            },
            canRemoveProfession(profession) {
                return this.shouldEditProfessions
                    && !this.workerTeams.map((team) => team.professionId).includes(profession.professionId);
            },
            redirectToTeam(teamId) {
                redirectService.redirectToTeam(teamId);
            },
            getProfessionQualification(profession) {
                return !profession.professionQualification || profession.professionQualification === 0 ? 'липсва' : profession.professionQualification;
            }
        },
        computed: {
            ...mapGetters(['allProfessions', 'allWorkerQualifications', 'professions', 'workerTeams', 'workerGeneralStatus', 'workerCompany']),

            shouldShowAddProfession() {
                return this.shouldEditProfessions;
            },

            getProfessionsForDropDown() {
                const currentProfessionIds = this.workerProfessions.map((profession) => profession.professionId);
                return this.allProfessions.filter((profession) => !currentProfessionIds.includes(profession.id));
            },

            getDefaultSelectedCompany() {
                if (this.workerCompany && this.workerCompany.id && this.companies) {
                    return this.companies.find(temp => temp.id === this.workerCompany.id);
                }
                return this.companies[0];
            }
        },
        watch: {
            professions: {
                handler(newVal) {
                    if (newVal) {
                        this.workerProfessions = cloneDeep(newVal);
                    }
                },
                deep: true
            },
            allWorkerQualifications: {
                handler(newVal) {
                    if (newVal) {
                        this.workerQualificationsCache = this.getWorkerQualifications();
                    }
                },
                deep: true
            }
        }
    }
</script>

<style scoped>
    .add-item-container {
        margin-top: 50px;
        width: 100%;
        display: inline-block;
    }

    .item-dropdown {
        width: 400px;
        float: left;
    }

    .add-item-icon {
        font-size: 40px;
        float: left;
        width: fit-content;
        height: 100%;
        margin: 36px;
        color: var(--slight-light-green);
    }

    .info-icon {
        color: var(--grey);
        float: left;
        margin-right: 20px;
        font-size: 23px;
    }

    .info-icon:hover {
        color: var(--primary-blue);
        cursor: pointer;
    }

    .input-worker-qualification {
        height: 90px;
        width: 180px;
        margin: 0 20px;
    }

    .input-worker-company {
        height: 90px;
        width: 300px;
        margin: 0 20px;
        float: left;
    }

    .save-company-button {
        float: left;
        width: 180px;
        height: 50px;
        font-size: 26px;
        margin: 30px 50px;
    }

    .edit-company-container {
        display: inline-block;
    }
</style>